import { useQuery } from 'react-query';
import http from '../config/http-service';

export interface IDedDetailSelectItem {
  id: number;
  label: string;
  businessName: string;
  licenseNumber: string;
  licenseStatus: string;
}

interface UseGetDedDetailsSelectApiParams {
  search?: string;
  limit?: number;
  enabled?: boolean;
}

export const useGetDedDetailsSelectApi = (
  params: UseGetDedDetailsSelectApiParams = {},
  options: { onError?: (error: any) => void } = {}
) => {
  const { search, limit = 100, enabled = true } = params;

  return useQuery({
    queryKey: ['ded-details-select', search, limit],
    queryFn: async (): Promise<IDedDetailSelectItem[]> => {
      const { data } = await http.get('ums/v1/crm/management/ded/licenses/select', {
        params: {
          search: search || undefined,
          limit,
        },
      });
      return data;
    },
    enabled,
    onError: options.onError,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};
